exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".set-price[data-v-e906ce2e]{width:10em;margin-bottom:1em}.set-price-header[data-v-e906ce2e]{text-align:center;padding-top:1em;padding-bottom:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e906ce2e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/admin-panel/components/admin/traffic-log-owner-report/TrafficPrice.vue
// module id = uFZ1
// module chunks = 0